/**
 * @file Basic Info Data
 */
// import moment from 'moment';
// import { TIME_FORMAT } from 'src/const/date';
import { COLUMN_WIDTH } from 'src/const/column-width';
import { moneyFormatterWithUnit } from 'src/const/statistics/formatters';


// Creative Info
export const EnumImageInfo = [
  {
    i18nPath: 'library_video_size',
    key: 'resolution',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
    formatter: image => image.resolution && `${image.resolution.width}*${image.resolution.height}`,
  },
  {
    i18nPath: 'library_image_created_date',
    key: 'create_time',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
    // formatter: image => moment.unix(image.create_time).format(TIME_FORMAT),
  },
];


export const EnumVideoDateInfo = [
  {
    i18nPath: 'module_library_material_date_create_on',
    key: 'create_time',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
    // formatter: video => moment.unix(video.create_time).format(TIME_FORMAT),
  },
  {
    i18nPath: 'module_library_material_date_modify_on',
    key: 'modify_time',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
    // formatter: video => moment.unix(video.modify_time).format(TIME_FORMAT),
  },
];
export const EnumVideoDetailsInfo = [
  {
    i18nPath: 'module_library_material_video_source',
    key: 'source',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
  },
  {
    i18nPath: 'module_library_material_video_duration',
    key: 'duration',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
  },
  {
    i18nPath: 'module_library_material_video_resolution',
    key: 'resolution',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
    formatter: ({ resolution }) => (resolution
      ? `${resolution.width} * ${resolution.height}`
      : '-'),
  },
  {
    i18nPath: 'module_library_material_video_creative_format',
    key: 'image_mode',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
  },
  {
    i18nPath: 'module_library_material_video_country',
    key: 'country_full_names',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
  },
  {
    i18nPath: 'module_library_material_video_placement',
    key: 'placement_ids',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
  },
  {
    i18nPath: 'module_library_material_video_total_active_days',
    key: 'total_active_days',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
  },
];

export const EnumVideoRelatedInfo = [
  {
    i18nPath: 'custom_setting_ad_creative_video_related_ads_count',
    key: 'creative_nums',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
  },
  {
    i18nPath: 'custom_setting_ad_creative_video_related_ad_groups_count',
    key: 'ad_nums',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
  },
  {
    i18nPath: 'custom_setting_ad_creative_video_top_ad_ids',
    key: 'creative_cost_top5',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
    hint: 'campaign_hover_stat_data.video_top_ad_ids',
  },
  {
    i18nPath: 'custom_setting_ad_creative_video_top_ad_cost',
    key: 'creative_cost_top5_total',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
    formatter: moneyFormatterWithUnit,
  },
  {
    i18nPath: 'custom_setting_ad_creative_video_top_ad_group_ids',
    key: 'ad_cost_top5',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
    hint: 'campaign_hover_stat_data.video_top_ad_group_ids',
  },
  {
    i18nPath: 'custom_setting_ad_creative_video_top_ad_group_cost',
    key: 'ad_cost_top5_total',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
    formatter: moneyFormatterWithUnit,
  },
];

export const EnumVideoInfo = [
  {
    i18nPath: 'common_video_duration',
    key: 'duration',
    'min-width': COLUMN_WIDTH.XL,
    align: 'right',
    'header-align': 'right',
    formatter: (row) => {
      // row.duration + 0.5 四舍五入
      let minute = parseInt((+row.duration + 0.5) / 60, 10);
      minute = (`${minute}`).length > 1 ? minute : `0${minute}`;
      let second = parseInt((+row.duration + 0.5) % 60, 10);
      second = (`${second}`).length > 1 ? second : `0${second}`;
      return `${minute}:${second}`;
    },
  },
  ...EnumImageInfo,
  ...EnumVideoDateInfo,
  ...EnumVideoDetailsInfo,
  ...EnumVideoRelatedInfo,
];
